/**
 * Analytics — fires PostHog + Google Analytics (gtag) in one call.
 *
 * Usage:
 *   import { track, page, identify, reset } from "@/lib/analytics";
 *
 *   track("render_completed", { action: "add", products: 2, duration_ms: 4200 });
 *   identify(user.id, { email: user.email, business_name: user.business_name, role: user.role });
 *   reset();   // on logout
 */

const ph = () => window.posthog;
const ga = () => typeof window.gtag === "function" ? window.gtag : null;

/** Fire a custom event to both PostHog and GA4. */
export function track(event, props = {}) {
  try { ph()?.capture(event, props); } catch {}
  try { ga()?.("event", event, props); } catch {}
}

/** Fire a page_view (called on every route change from App.js). */
export function page(path, title) {
  try { ph()?.capture("$pageview", { $current_url: window.location.href }); } catch {}
  try {
    ga()?.("event", "page_view", {
      page_path: path,
      page_title: title || document.title,
    });
  } catch {}
}

/** Identify an authenticated user so events are tied to them. */
export function identify(userId, traits = {}) {
  try { ph()?.identify(userId, traits); } catch {}
  try {
    ga()?.("set", "user_properties", traits);
    ga()?.("set", { user_id: userId });
    ga()?.("config", "G-X7SXK5TNSD", { user_id: userId });
  } catch {}
}

/** Reset identity on logout. */
export function reset() {
  try { ph()?.reset(); } catch {}
  try { ga()?.("set", { user_id: null }); } catch {}
}
